import { useAuthRestApi } from '../common';
import { Observable } from 'rxjs';
import { IResultRequest, IResultRequestApi } from '@vivli/features/results-request/infrastructure/interface';
import { ResultsRequestStatusEnum } from '@vivli/features/results-request/infrastructure/enum';

export const useResultRequestApi = (): IResultRequestApi => {
    const { handleGet, handlePost } = useAuthRestApi();
    const getResultRequests = (dataRequestId: string): Observable<IResultRequest[]> => {
        return handleGet<IResultRequest[]>(`/dataRequests/${dataRequestId}/resultsRequests`);
    };

    const createResultRequest = (dataRequestId: string): Observable<IResultRequest> => {
        return handlePost<IResultRequest>(`/dataRequests/${dataRequestId}/researchEnvironment/CreateNewResultRequest`);
    };

    const updateResultRequestStatus = (
        dataRequestId: string,
        resultsRequestId: string,
        status: ResultsRequestStatusEnum
    ): Observable<IResultRequest> => {
        return handlePost<IResultRequest>(
            `/dataRequests/${dataRequestId}/researchEnvironment/${resultsRequestId}/UpdateResultsRequest/${status}`
        );
    };

    const approveResultRequest = (dataRequestId: string, resultsRequestId: string): Observable<IResultRequest> => {
        return handlePost<IResultRequest>(`/dataRequests/${dataRequestId}/resultsRequests/${resultsRequestId}/approve`);
    };

    const disapproveResultRequest = (dataRequestId: string, resultsRequestId: string, comment?: string): Observable<IResultRequest> => {
        return handlePost<IResultRequest>(`/dataRequests/${dataRequestId}/resultsRequests/${resultsRequestId}/disapprove`, comment);
    };

    return {
        getResultRequests,
        createResultRequest,
        updateResultRequestStatus,
        approveResultRequest,
        disapproveResultRequest
    };
};
